import React from 'react';
import ProofAttachmentDropzone from '../../Common/ProofAttachmentDropzone';

export const SLIP_MAX_MB = 5;
export const MAX_SLIPS = 5;

/**
 * One or more bank slips for a single payment (a member who paid in parts, e.g. two transfers).
 * Controlled: `files` is an array (empty slots are null), `onChange(files)`.
 * `max` = how many slips can still be attached here.
 */
const MultiSlipPicker = ({ files, onChange, max = MAX_SLIPS, required = false, hint, disabled = false }) => {
  const slots = files.length ? files : [null];
  const setAt = (i, file) => onChange(slots.map((f, j) => (j === i ? file : f)));
  const removeAt = (i) => onChange(slots.filter((_, j) => j !== i));
  const canAdd = slots.length < max && slots.every(Boolean);

  return (
    <div className="space-y-3">
      {slots.map((file, i) => (
        <div key={i} className="relative">
          <ProofAttachmentDropzone
            file={file}
            onChange={(f) => setAt(i, f)}
            label={slots.length > 1 ? `Bank slip ${i + 1}` : 'Bank slip'}
            required={required && i === 0}
            hint={i === 0 ? hint : '(another part of the payment)'}
            maxSizeMb={SLIP_MAX_MB}
            accept="image/jpeg,image/png,application/pdf"
            disabled={disabled}
          />
          {i > 0 && (
            <button
              type="button"
              onClick={() => removeAt(i)}
              disabled={disabled}
              className="absolute right-0 top-0 text-xs font-medium text-rose-600 hover:underline disabled:opacity-50"
            >
              Remove slip {i + 1}
            </button>
          )}
        </div>
      ))}
      {max > 1 && (
        <div className="flex items-center justify-between gap-3">
          <button
            type="button"
            onClick={() => onChange([...slots, null])}
            disabled={!canAdd || disabled}
            className="inline-flex items-center gap-1.5 rounded-lg border border-violet-200 px-3 py-1.5 text-sm font-medium text-violet-700 hover:bg-violet-50 disabled:cursor-not-allowed disabled:opacity-40"
          >
            <span aria-hidden="true">+</span> Add another slip
          </button>
          <span className="text-xs text-gray-500">
            Paid in more than one transfer? Add each slip. Up to {max} slip{max === 1 ? '' : 's'}.
          </span>
        </div>
      )}
    </div>
  );
};

/** The chosen files only (empty slots dropped). */
export const chosenSlips = (files) => (files || []).filter(Boolean);

export default MultiSlipPicker;
